import {OutlinedInputProps} from "@mui/material";


export const hideNumberSpinner: Partial<OutlinedInputProps> = {
	  inputProps: {
			 style: {
					appearance: "textfield",
					MozAppearance: "textfield",
					WebkitAppearance: "textfield"
			 }
	  }
};

export const singleLineText = {
	  overflow: "hidden",
	  textOverflow: "ellipsis",
	  whiteSpace: "nowrap"
};